import { css } from "styled-components";

export const aStyles = css`
  color: ${({
    theme: {
      colors: { darkGrey },
    },
  }) => darkGrey};
  text-decoration: none;

  :active,
  :focus,
  :hover {
    text-decoration: underline;
  }
`;
